import { render, staticRenderFns } from "./selectPerson.vue?vue&type=template&id=99fb4092&scoped=true&"
import script from "./selectPerson.vue?vue&type=script&lang=js&"
export * from "./selectPerson.vue?vue&type=script&lang=js&"
import style0 from "./selectPerson.vue?vue&type=style&index=0&id=99fb4092&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99fb4092",
  null
  
)

export default component.exports